module.exports = __webpack_public_path__ + "static/drips-8bfb0f656fef09cae31173a02a1b6530.jpg";